module.exports = __webpack_public_path__ + "static/media/nestje2.6cca2e85.webp";